import { Type } from 'class-transformer';
import { SORespEntity } from '../entity/so-resp-entity';
import { SORespCustomLogicRequirement } from '../custom-logic-requirement/so-resp-custom-logic-requirement';
import { SORespRelationship } from '../relationship/so-resp-relationship';
import { SORespProject } from '../project/so-resp-project';
import { SORespOrganization } from '../organization/so-resp-organization';
import {ENMultiplicity} from '../../enums';
import {ObjectiveProtocol} from 'lionheartland';
import {RelationshipAttribute} from "../../dexie/db";

export class SORespRelationshipAttribute implements ObjectiveProtocol {

  entityType: string = 'relationshipAttribute';
  uid: string;
  name: string;
  description: string = "";
  multiplicity: ENMultiplicity;
  editPermissions: boolean;
  @Type(() => SORespEntity)
  entity: SORespEntity;
  @Type(() => SORespCustomLogicRequirement)
  customLogicRequirement: SORespCustomLogicRequirement = null;
  @Type(() => SORespRelationship)
  relationship: SORespRelationship = null;
  @Type(() => SORespProject)
  project: SORespProject;
  @Type(() => SORespOrganization)
  organization: SORespOrganization;

    toRelationshipAttribute(): RelationshipAttribute {
        return {
            uid: this.uid,
            name: this.name,
            description: this.description,
            multiplicity: this.multiplicity,
            dateCreated: null,
            editPermissions: this.editPermissions,
            relationshipAttributePermissionsUid: null,
            relationshipAttributePermissionRulesUid: null,
            realizationsUid: null,
            entityUid: this.entity ? this.entity.uid : null,
            customLogicRequirementUid: this.customLogicRequirement ? this.customLogicRequirement.uid : null,
            relationshipUid: this.relationship ? this.relationship.uid : null,
            attributeSpecsUid: null,
            projectUid: this.project ? this.project.uid : null,
            organizationUid: this.organization ? this.organization.uid : null,
}

        };
}